import { FunctionComponent, memo } from 'react';
import { CodeBlockData } from '../../../../shared';

import classes from './Code.module.scss';

export const Code: FunctionComponent<CodeBlockData> = memo(({ code }) => {
  return <div className={classes['code']}>{code}</div>;
});
